import { Guid } from './guid';

const buildConfig = require('../build/' + (process.env.BUILD_ENV || 'dev') + '.js');

function generateTraceId() {
  const timestamp = Date.now().toString(36); // 时间戳转36进制
  const randomPart = Math.random().toString(36).substring(2, 8); // 随机字符串
  return `${timestamp}-${randomPart}`;
}

const Http = function (identity, isFromShortTermLive = false) {
  this.identity = identity;
  this.tokenKey = identity + 'Token';
  this.schoolKey = identity + 'School';
  this.isFromShortTermLive = isFromShortTermLive;
  let DeviceID = localStorage.DeviceID;
  if (!DeviceID) {
    DeviceID = Guid.NewGuid().ToString('D');
    localStorage.DeviceID = DeviceID;
  }
  this.DeviceID = DeviceID;
  this.baseUrl = buildConfig.BASE_URL;
};

/**
 * fetch请求
 * @param {String} url 接口地址
 * @param {String} method http方法
 * @param {Object} params 请求参数
 * @param {Boolean|Object} httpConfig 配置1、布尔类型：接口是否有权限控制，默认false 2、对象类型：isAuthRequest:接口是否有权限控制，默认false；showLoading：是否显示loading效果，默认true
 * @returns {Object}
 */
Http.prototype.fetch = function (url, method, params = {}, httpConfig = {}, token) {
  let isAuthRequest = httpConfig.isAuthRequest;
  let showLoading = httpConfig.showLoading;
  if (!httpConfig.fullUrl) {
    url = this.baseUrl + url;
  }
  if (this.beforeRequest) {
    if (!this.beforeRequest(isAuthRequest, showLoading)) {
      return new Promise(() => {});
    }
  }
  let config = {
    method: method,
    mode: 'cors',
  };
  config.headers = {
    DeviceType: 'PC',
    DeviceID: this.DeviceID,
    'F-Trace-Id': generateTraceId(),
  };
  if (this.isFromShortTermLive) {
    config.headers.UserScenario = 'ShortLivePcH5';
  }
  // if (this.identity == "student") {
  //   config.headers.SchoolID =
  //     httpConfig.school_id || localStorage[this.schoolKey] || 0;
  // }
  // config.headers.SchoolID = httpConfig.school_id || localStorage[this.schoolKey] || 0;
  // 网校请求schoolID都为2
  config.headers.SchoolID = 2;
  if (params instanceof FormData) {
    config.body = params;
  } else {
    if (method == 'get' || method == 'head') {
      if (url.indexOf('?') > 0) {
        url += '&';
      } else {
        url += '?';
      }
      for (let key in params) {
        let value = params[key];
        if (typeof value == 'function' || value === undefined || value === '') {
          continue;
        }
        url += key + '=' + params[key] + '&';
      }
    } else {
      config.body = JSON.stringify(params);
    }
    config.headers['Content-Type'] = 'application/json';
  }
  if (localStorage[this.tokenKey] || token) {
    config.headers.Authorization = 'Bearer ' + (token ? token : localStorage[this.tokenKey]);
  }
  return new Promise((resolve, reject) => {
    fetch(url, config).then(async (res) => {
      if (this.afterRequest) {
        this.afterRequest();
      }
      if (res.status == 200) {
        let data = await res.json();
        if (
          data.code == 200 ||
          (data.code == 205 &&
            (data.data.need_collect_data || url.indexOf('/api/app/user/collect') >= 0))
        ) {
          resolve(data.data || data);
        } else if (data.code == '000000') {
          // 兼容AI数学业务线
          resolve(data.data);
        } else if (data.code == 203) {
          resolve(data);
        } else if (data.code == 4004) {
          window.location.href = buildConfig.BASE_URL + '/404.html';
        } else if (data.code == 205) {
          resolve(data.data || data);
          if (this.onApiError) {
            if (httpConfig.inject) {
              Object.assign(data, httpConfig.inject);
            }
            this.onApiError(data);
          }
        } else if (data.code == 1201) {
          // 校验登录获取验证码是否成功,失败时需要弹窗输入图形验证码
          resolve(false);
        } else if (httpConfig.onError) {
          httpConfig.onError(data);
        } else if (this.onApiError) {
          if (httpConfig.inject) {
            Object.assign(data, httpConfig.inject);
          }
          this.onApiError(data);
          if (httpConfig.retError) {
            resolve(null);
          }
        }
        if (httpConfig.allowReject) {
          reject(data.msg);
        }
      } else {
        reject(res.statusText);
      }
    });
  });
};

function buildHttpConfig(isAuthRequest) {
  let config;
  if (typeof isAuthRequest == 'boolean') {
    config = {
      isAuthRequest,
    };
  } else {
    config = isAuthRequest;
  }
  if (config.showLoading === undefined) {
    config.showLoading = true;
  }
  return config;
}

Http.prototype.get = function (url, params, isAuthRequest = false, token) {
  return this.fetch(url, 'get', params, buildHttpConfig(isAuthRequest), token);
};

Http.prototype.post = function (url, params, isAuthRequest = false, token) {
  return this.fetch(url, 'post', params, buildHttpConfig(isAuthRequest), token);
};

Http.prototype.put = function (url, params, isAuthRequest = false) {
  return this.fetch(url, 'put', params, buildHttpConfig(isAuthRequest));
};

Http.prototype.delete = function (url, params, isAuthRequest = false) {
  return this.fetch(url, 'delete', params, buildHttpConfig(isAuthRequest));
};

export default {
  build: (tokenKey, schoolKey) => {
    return new Http(tokenKey, schoolKey);
  },
};
